import React, { useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, gql } from "@apollo/client";

import { Link, useNavigate } from "react-router-dom";

import ThemeContext from "../../../../../context/ThemeContext";
import UserContext from '../../../../../context/UserContext';
import { TabView, TabPanel } from 'primereact/tabview';
import { InputText } from "primereact/inputtext";
import { InputNumber } from 'primereact/inputnumber';
import { Fieldset } from 'primereact/fieldset';
import { RadioButton } from "primereact/radiobutton";
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
//import HtlFloorPlan from "./HtlFloorPlan";
//import HtlPeriods from "./HtlPeriods";

import {IntlProvider, FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import messages from '../../../../../lang/LangGlb';




const GET_POST = gql`
query MyQuery(
    $resMidId: Int
    $resRoomId: Int
    $resRoomDtlId: Int
    $ownFirmCode: String
    $ownFirmSubCode: String
    ) {
        tbl_rez_room_dtl(where: {
        rez_mid_id: {_eq: $resMidId}
        rez_room_id: { _eq: $resRoomId }
        room_dtl_id: { _eq: $resRoomDtlId }
        firm_main_code: { _eq: $ownFirmCode }
        firm_sub_code: { _eq: $ownFirmSubCode }
    }) {
        rez_mid_id
        rez_room_id
        room_code
        product_code
        type
        quantity
        unit
        price_base
        price
        currency
        date
        credit
        debit
        firm_main_code
        firm_sub_code
   
    
  

  }
  tbl_rez_room_dll_calc(where: {
    rez_room_dtl_id: {_eq: $resRoomDtlId}}) {
        rez_mid_id
        rez_room_id   
        rez_room_dtl_id 
    firm_main_code
    firm_sub_code
    code
    value
    type
   
    
  }
  
}
`;




const INSERT_SEA = gql`
  mutation InsertRules(
    $rulPernId: Int
    $rulSubId: Int
    $ownFirmCode: String
    $ownFirmSubCode: String
    $rulesName: String   
    $ruleType: String
    $startDate: date
    $endDate: date
    $fmActive: Boolean

   
    
  ) {
    insert_tbl_build_plan

    (
      objects: {
        firm_main_code: $ownFirmCode,
        firm_sub_code: $ownFirmSubCode,
        build_id: $rulPernId,
        build_plan_id: $rulSubId,
        build_plan_type: $ruleType,
        name: $rulesName,
       
       

        
      }
    ) {
      affected_rows
    }
  }
`;


const GET_POST_TYPE = gql`
  query MyQuery( $lang: String ) {
    tbl_gnl_cards(
      where: {        
        lang: { _eq: $lang } ,
        gnl_type: { _eq: "FOL" } 
      
          
      }
    ) {
      lang
      gnl_card_code
      gnl_card_name
      gnl_type
    
    }
  }
`;


const GET_PRODUCT = gql`
  query MyQuery( $lang: String, $defType: String, $ruleClass2: String,  $ownFirmCode: String, $ownFirmSubCode: String) {
    tbl_product(
      where: {   
       
        firm_main_code: { _eq: $ownFirmCode },
        firm_sub_code: { _eq: $ownFirmSubCode },
        
       
      }
    ) {
        prod_code
        prod_name
     
    }
  }
`;

const GET_ROOM_TYPE = gql`
query GetHtlRoomsTyp(
    $ownFirmCode: String
    $ownFirmSubCode: String
   
  ) {
    tbl_htl_room_type(
      order_by: { r_class_code: asc },
      where: {
        firm_main_code: { _eq: $ownFirmCode }
        firm_sub_code: { _eq: $ownFirmSubCode }
      
      }
    ) {
     
      r_class_code
      r_type_code
      r_type_name     
      active
    }
  }
`;



const UPDATE_RULES = gql`
mutation UpdateRules(
    $rulPernId: Int
    $rulSubId: Int
    $ownFirmCode: String
    $ownFirmSubCode: String
    $rulesName: String   
    $ruleType: String
   
    
  ) {
    update_tbl_build_plan(
      where: {
        build_plan_id: { _eq: $rulSubId }
        build_id: { _eq: $rulPernId }
        firm_main_code: { _eq: $ownFirmCode }
        firm_sub_code: { _eq: $ownFirmSubCode }
      }
      _set: {
        
        build_plan_type: $ruleType
        name: $rulesName
       
      }
    ) {
      affected_rows
    }
  }
`; 

const UPDATE_ID_SEQ2 = gql`
mutation UpdateIdSeq2($type: String!) {
  update_tbl_id_SEQ(
    where: { type: { _eq: $type } }
    _inc: { id_seq: 1 }
  ) {
    returning {
      id_seq
    }
  }
}
`;




//Building Plan Form

const HtlResRoomFolioDtl = () => {

   const {varCode, setVarCode} = useContext(ThemeContext);
   const {varCode4, setVarCode4} = useContext(ThemeContext);
   const {varCode8, setVarCode8} = useContext(ThemeContext);
   const {varCode9, setVarCode9} = useContext(ThemeContext);
   const {varCode10, setVarCode10} = useContext(ThemeContext);
   const {varCode11, setVarCode11} = useContext(ThemeContext);
   const {varCode12, setVarCode12} = useContext(ThemeContext);
  const {userName, setUserName} = useContext(ThemeContext);
  const { users } = useContext(UserContext);

  const ownFirmCode = users.firmcode;
  const ownFirmSubCode = users.subfirmcode;
  const ownFirmSubType = users.usertype;
  

  const lang = users.userLang;

 

  

     
   
  
  
  const { loading, error, data, refetch } = useQuery(GET_POST, {
    variables: { resMidId: varCode4, ownFirmCode: ownFirmCode, ownFirmSubCode: ownFirmSubCode, resRoomId: varCode8, resRoomDtlId: varCode9  },
  });


  const firmData = data && data.tbl_rez_room_dtl ? data.tbl_rez_room_dtl[0] : null;
  const firmData2 = data && data.tbl_floor_map ? data.tbl_floor_map[0] : null;
 

  const [updateRulesSub] = useMutation(UPDATE_RULES);
  const [updateIdSeq2] = useMutation(UPDATE_ID_SEQ2); 
  const [InsertSeason] = useMutation(INSERT_SEA);

  const [displayBasic, setDisplayBasic] = useState(false);

  
  
  
 // const [firmCode, setFirmcode] = useState(firmData ? firmData.firm_main_code_n : "");
 const [firmCode, setFirmCode] = useState('');
 const [firmName, setFirmName] = useState(""); 
 const [rulSubId, setRulSubnId] = useState(firmData ? firmData.rez_mid_id : "");  
 const [ruleType, setRuleType] = useState(firmData ? firmData.rez_mid_id : ""); 
 const [rulesName, setRulesName] = useState(firmData ? firmData.rez_mid_id : "");  
 const [rulesType, setRulesType] = useState(firmData ? firmData.rez_mid_id : "");  
  


 const [resMidId, setResMidIdd] = useState(firmData ? firmData.rez_mid_id : "");  
  const [resRoomId, setResRoomIdd] = useState(firmData ? firmData.rez_room_id : ""); 
  const [resRoomDtlId, setResRoomDtlId] = useState(firmData ? firmData.room_dtl_id : ""); 
  const [resRoomCode, setResRoomCode] = useState(firmData ? firmData.room_code : ""); 
  const [productCode, setProductCode] = useState(firmData ? firmData.product_code : ""); 
  const [resDtlType, setResDtlType] = useState(firmData ? firmData.type : ""); 
  const [resDtlUnit, setResDtlUnit] = useState(firmData ? firmData.unit : ""); 
  const [resDtlPrice, setResDtlPrice] = useState(firmData ? firmData.price : ""); 
  const [resDtlBasePrice, setResDtlBasePrice] = useState(firmData ? firmData.price_base : ""); 
  const [resDtlcurrency, setResDtlCurrency] = useState(firmData ? firmData.currency : ""); 
  const [resDtlCredit, setResDtlCredit] = useState(firmData ? firmData.credit : ""); 
  const [resDtlDebit, setResDtlDebit] = useState(firmData ? firmData.debit : ""); 
  const [resDtlQuant, setResDtlQuant] = useState(firmData ? firmData.quantity : ""); 
  

  const [folioDate, setFolioDate] = useState(firmData ? new Date(firmData.date): new Date());

  const [openModal, setOpenModal] = useState(false);
  const [modalParam, setModalParam] = useState('');
  const [verim, setVerim] = useState('T0002');
  const {theme, setTheme} = useContext(ThemeContext);



  const [activeTab, setActiveTab] = useState(0);
  const [activeTabS, setActiveTabS] = useState(9);

  const handleTabChange = (index) => {
    setActiveTab(index);
  };

  const handleTabChangeS = (index) => {
    setActiveTabS(index);
  };



  
  const intl = useIntl();
  const currentLocale = users.userLang || localStorage.getItem('lang') || 'en';
  const rule_detail_title = messages[currentLocale].rule_detail_title;
  const rule_id_title = messages[currentLocale].rule_id_title;
  const rule_class_title = messages[currentLocale].rule_class_title;
  const rule_class_name_title = messages[currentLocale].rule_class_name_title;
  const select_rule_type_hint = messages[currentLocale].select_rule_type_hint;
  const new_premises_btn = messages[currentLocale].new_premises_btn;
  const currentPageReportTemplate = messages[currentLocale].currentPageReportTemplate;
  const statusrec = messages[currentLocale].statusrec;
  const activerec = messages[currentLocale].activerec;
  const inactiverec = messages[currentLocale].inactiverec;
  const update = messages[currentLocale].update;
  const new_rule_btn = messages[currentLocale].new_rule_btn;
  const premises_management_title = messages[currentLocale].premises_management_title;
  const rule_grp_id_title = messages[currentLocale].rule_grp_id_title;
  const rule_type_title = messages[currentLocale].rule_type_title;
  const detail = messages[currentLocale].detail;
  const start_date_title = messages[currentLocale].start_date_title;
  const end_date_title = messages[currentLocale].end_date_title;
  


  const { loading: defLoading, error: defError, data: defData } = useQuery(GET_PRODUCT, {
    variables: {ownFirmCode: ownFirmCode, ownFirmSubCode: ownFirmSubCode },
  });

  const { loading: defLoading2, error: defError2, data: defData2 } = useQuery(GET_ROOM_TYPE, {
    variables: { ownFirmCode: ownFirmCode, ownFirmSubCode: ownFirmSubCode},
  });

  const { loading: defLoading3, error: defError3, data: defData3 } = useQuery(GET_POST_TYPE, {
    variables: {lang: lang },
  });




  useEffect(() => {
    // newId değeri bağlamdaki yeni değeri yansıtır
    if (rulSubId !== '') {
      // newId güncellendiğinde setFirmCode işlevini çağırarak firmCode'u güncelliyor
    handleinser();  
    
    }
  }, [rulSubId, setRulSubnId]);


  useEffect(() => {
    if (defData && defData.tbl_product) {
      const productItems = defData.tbl_product.find(item => item.prod_code === ruleType);
      if (productItems) {
        setRulesName(productItems.prod_name);
      }
    }
  }, [productCode, setProductCode, defData]);

  

  useEffect(() => {
    if (firmData) {

   

        setResMidIdd(firmData.rez_mid_id); 
        setResRoomIdd(firmData.rez_room_id); 
        setResRoomDtlId(firmData.room_dtl_id); 
        setResRoomCode(firmData.room_code); 
        setProductCode(firmData.product_code); 
        setResDtlType(firmData.type); 
        setResDtlUnit(firmData.unit); 
        setResDtlBasePrice(firmData.price_base); 
        setResDtlPrice(firmData.price);
        setResDtlCurrency(firmData.currency);        
        setFolioDate(new Date(firmData.date));
        setResDtlCredit(firmData.credit);  
        setResDtlDebit(firmData.debit); 
        setResDtlQuant(firmData.quantity); 
        


   
     
          
    }
  }, [firmData]);




  const handleUpdate = () => {
   
    
    updateRulesSub({
      variables: {
      
        ownFirmCode: ownFirmCode,
        ownFirmSubCode: ownFirmSubCode,      
    
    //    startDate: new Date(startDate).toLocaleDateString(),
     //   endDate: new Date(endDate).toLocaleDateString(),
   //     fmActive: fmActive,

        
      },
    })
      .then(() => {
        window.alert("Firm updated successfully!");
        refetch();
       
      })
      .catch((error) => {
        console.error("Error updating firm:", error);
      });
  }; 

  const handleUpdateIdSeq = async () => {
    const requiredFields = ['rulesName', 'ruleType' ]; // Required fiels
    const customFieldNames = {
      rulesName: "Offer Name",
    //  ruleClass: "Rules Class",
      ruleType: "Rules Type",

    

    };
    const emptyFields = getEmptyFields(requiredFields, customFieldNames); // Boş alanları kontrol et
  
    if (emptyFields.length === 0) {
      try {
        const { data } = await updateIdSeq2({
          variables: {
            type: 'MFIRM', 
          },
        });
        const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
        console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
        setRulSubnId(updatedIdSeq); 
     //   setIdSeqTrg(updatedIdSeq);
        
      //  console.log(rulSubId);
        // setVarCode(updatedIdSeq.toString());  
      } catch (error) {
        console.error('Güncelleme hatası:', error);
      }
    } else {
      
      const emptyFieldsMessage = `Boş Alanları Doldurun: ${emptyFields.join(', ')}`;
     // console.log(emptyFieldsMessage);
      window.alert(emptyFieldsMessage);
    }
  };

  const getEmptyFields = (requiredFields, customFieldNames) => {
    const emptyFields = [];
  
    // Boş olan alanları bul
    for (const field of requiredFields) {
      if (!eval(field)) {
        emptyFields.push(customFieldNames[field]);
      }
    }
  
    return emptyFields;
  };

  const handleinser = () => {
    InsertSeason({
      variables: {

        ownFirmCode: ownFirmCode,
        ownFirmSubCode: ownFirmSubCode,
        rulPernId: varCode,
        
    
    
           
      },
    })
      .then(() => {
        window.alert("Rules insert successfully!");
    //    setVarCode8(rulSubId);
      })
      .catch((error) => {
        console.error("Error insert Rules:", error);
      });
  };


  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

      
  const onClick = () => {
    setVarCode11(ruleType); //EBO
  //  setVarCode8(rulSubId);
    setDisplayBasic(true);
    
  };

  const onClick2 = () => {
   // setVarCode10(0);  
    setVarCode11(ruleType); //EBO
    setVarCode10(0); //EBO
    setDisplayBasic(true);
    
  };
  
  const onHide = () => {
    setDisplayBasic(false);
    refetch();
  };


  const getStatusLabel = (rowData) => {
    const statusClass = rowData.active
      ? "text-purple-800 font-bold text-sm"
      : "text-gray-500 font-bold text-sm";
  
    return (
      <div className={statusClass}>
      {rowData.active ? (
        <FormattedMessage id={activerec} />
      ) : (
        <FormattedMessage id={inactiverec} />
      )}
    </div>
    );
  };


  const productItems = defData && defData.tbl_product
  ? defData.tbl_product.map(item => ({
      label: item.prod_name,
      value: item.prod_code,
      name: item.prod_name, 
    }))
  : [];

  const roomTypeItems = defData2 && defData2.tbl_htl_room_type
  ? defData2.tbl_htl_room_type.map(item => ({
      label: item.r_type_name,
      value: item.r_type_code,
      name: item.r_type_name, 
    }))
  : [];


  const postTypeItems = defData3 && defData3.tbl_gnl_cards
  ? defData3.tbl_gnl_cards.map(item => ({
      label: item.gnl_card_name,
      value: item.gnl_card_code,
      name: item.gnl_card_name, 
    }))
  : [];






  return (

    <div className="container -mt-4 mx-auto sm:p-4 ">
      
  
   


         <TabView className="flex m-0 p-0 list-none flex-nowrap" activeIndex={activeTab} onTabChange={(e) => handleTabChange(e.index)}>
           <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 0 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Folio Detail"}
            </span>
          }
          className="ml-2 flex"
        >
      <div>

    
   
         <div className="pt-1"> 
           <Fieldset>
             <p className="my-0  ">
    


      <div className=" flex gap-4">
        
          <div className="w-1/4 p-inputtext-sm gap-3">
            
    <label className="p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">{rule_id_title}</label>
    <InputText className="w-full text-base" 
    id="username" value={resRoomId}
    onChange={(e) => setResRoomIdd(e.target.value)}
    readOnly
    />
  </div>





  <div className="w-1/2 gap-3">
        <label                
         htmlFor="firmname"> {"Departure"}</label>
        <Calendar className="w-1/8 h-11" 
        inputStyle={{ showIcon: 'text-gray-900', width:'80%'  }}
        style={{ width:"%80" }}    
        id="firmname" value={folioDate} dateFormat="dd/mm/yy"
        onChange={(e) => setFolioDate(e.target.value)} 
        showIcon
        locale="tr"/>
      </div>



  
  
  <div className="w-1/4 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{rule_class_title}</label>
    <InputText className="w-full text-base" 
    id="firmname" value={resRoomCode} 
    onChange={(e) => setResRoomCode(e.target.value)} autoComplete="off"/>
    
  </div>

  <div>
        <label htmlFor="roomClassDropdown" className="font-medium text-gray-700">
        {"Type Name"}
       </label>
       <Dropdown
       className="h-11  w-56 rounded-md" 
        style={{ width: '244px' }} 
        dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
         <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
         </svg>}
         value={resRoomCode}
         options={roomTypeItems}
         onChange={(e) => setResRoomCode(e.value)}
         placeholder={select_rule_type_hint}
         />
       </div>

       <div className="w-1/4 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{"Post Type"}</label>
    <InputText className="w-full text-base" 
    id="firmname" value={resDtlType} 
    onChange={(e) => setResDtlType(e.target.value)} autoComplete="off"/>    
  </div>

  <div>
        <label htmlFor="roomClassDropdown" className="font-medium text-gray-700">
        {"Type Name"}
       </label>
       <Dropdown
       className="h-11  w-56 rounded-md" 
        style={{ width: '244px' }} 
        dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
         <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
         </svg>}
         value={resDtlType}
         options={postTypeItems}
         onChange={(e) => setResDtlType(e.value)}
         placeholder={select_rule_type_hint}
         />
       </div>


  
  
      </div>  

  


  
  <div className="flex gap-3 my-5">

  <div className="w-1/5 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{"Product"}</label>
    <InputText className="w-full text-base" 
    id="firmname" value={productCode} 
    onChange={(e) => setProductCode(e.target.value)} autoComplete="off"/>
    
  </div>

  <div>
        <label htmlFor="roomClassDropdown" className="font-medium text-gray-700">
        {"Product Name"}
       </label>
       <Dropdown
       className="h-11  w-56 rounded-md" // Bu satır eklenmiştir
        style={{ width: '244px' }} 
        dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
         <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
         </svg>}
         value={productCode}
         options={productItems}
         onChange={(e) => setProductCode(e.value)}
         placeholder={select_rule_type_hint}
         />
         
       </div>

       <div className="w-1/5 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{"Quantity"}</label>
    <InputText className="w-full text-base" 
    id="firmname" value={resDtlQuant} 
    onChange={(e) => setResDtlQuant(e.target.value)} autoComplete="off"/>
    
  </div>

  <div className="w-1/5 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{"Unit"}</label>
    <InputText className="w-full text-base" 
    id="firmname" value={resDtlUnit} 
    onChange={(e) => setResDtlUnit(e.target.value)} autoComplete="off"/>
    
  </div>

  <div className="w-1/5 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{"Base Price"}</label>
    <InputText className="w-full text-base" 
    id="firmname" value={resDtlBasePrice} 
    onChange={(e) => setResDtlBasePrice(e.target.value)} autoComplete="off"/>
    
  </div>

  <div className="w-1/5 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{"Price"}</label>
    <InputText className="w-full text-base" 
    id="firmname" value={resDtlPrice} 
    onChange={(e) => resDtlPrice(e.target.value)} autoComplete="off"/>
    
  </div>

  <div className="w-1/5 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{"Currency"}</label>
    <InputText className="w-full text-base" 
    id="firmname" value={resDtlcurrency} 
    onChange={(e) => setResDtlCurrency(e.target.value)} autoComplete="off"/>
    
  </div>

  <div className="w-1/5 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{"Debit"}</label>
    <InputText className="w-full text-base" 
    id="firmname" value={resDtlDebit} 
    onChange={(e) => setResDtlDebit(e.target.value)} autoComplete="off"/>
    
  </div>

  <div className="w-1/5 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{"Credit"}</label>
    <InputText className="w-full text-base" 
    id="firmname" value={resDtlCredit} 
    onChange={(e) => setResDtlCredit(e.target.value)} autoComplete="off"/>
    
  </div>

  
      </div>
      <div className="flex  gap-4 ">
      <div className="w-3/4">
     
  </div>
  <div className="w-2/4">
    <Button
      label={new_premises_btn}
      aria-label="Update"
      className="w-full p-button-sm p-button-outlined bg-purple-900 hover:bg-violet-900 text-white font-semibold rounded-md"
      onClick={onClick2}
    />
  </div>
  <div className="w-2/4">
    <Button
      label={update}
      aria-label="Update"
      className="w-full p-button-sm p-button-outlined bg-purple-900 hover:bg-violet-900 text-white font-semibold rounded-md"
      onClick={handleUpdate}
    />
  </div>
  <div className="w-2/4">
    <Button
      label={new_rule_btn}
      aria-label="Update"
      className="w-full p-button-sm p-button-outlined bg-purple-800 hover:bg-indigo-500 text-white font-semibold rounded-md"
      onClick={handleUpdateIdSeq}
    />
  </div>
</div>

<div>
<Dialog visible={displayBasic} style={{ width: '55vw' }}header={"Floor Plan"} onHide={onHide}>
  <p>
   
  </p>
</Dialog>
</div>
</p>
   </Fieldset>
       </div>
 
       </div>          
  
 


 <p> <DataTable
         value={data.tbl_rez_room_dll_calc }
         scrollable 
         scrollHeight="250px" loading={loading}
         stickyHeader
         stickyTopAt=".layout-topbar"
        

        >
           <Column field="rez_room_dtl_id"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{"Id"}</span>}
           style={{ textAlign: 'left', width: '6rem' }}
          >
          </Column>
          <Column field="rez_room_id"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{rule_grp_id_title}</span>}
           style={{ textAlign: 'left', width: '6rem' }}
          >
          </Column>

          <Column field="code"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{"Code"}</span>}
           style={{ textAlign: 'left', width: '7rem' }}
          >
          </Column>
          <Column field="value"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{rule_type_title}</span>}
           style={{ textAlign: 'left', width: '12rem' }}
          >
          </Column>


          <Column
          header={<span className="font-bold text-sm text-gray-900">{detail}</span>}
          body={(rowData) => (
            <button
              onClick={() => {               
                setVarCode10(rowData.floor_id);  
              //  setVarCode(rowData.sea_id_seq);                          
                onClick();
              
                
              }}
              className="p-1 rounded-full dark:text-gray-600 hover:dark:bg-gray-700 focus:dark:bg-gray-700"
            >
              <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
                <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
              </svg>
            </button>
          )}
          style={{ textAlign: 'center', width: '6rem' }}
        ></Column>
    
        </DataTable></p>    

              </TabPanel>
              <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 1 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Additional"}
            </span>
          }
          className="ml-5 flex"
        >
    

              </TabPanel>
            
          </TabView>   
     
    </div>




    
    
    
 
 
);
};

export default HtlResRoomFolioDtl;
